<template>
  <div class="exterior_div color__select">
    <div class="color_image">
      <div class="border_color">
        <carousel
          :slides-per-view="swiperOption.slidesPerView"
          :breakpoints="swiperOption.breakpoints"
          :navigation="navigationDisplay()"
        >
          <slide
            v-for="(detail, index) in color_images"
            :key="index"
            class="exterior_slide2"
          >
            <input
              @click="click_color_image(detail.code, index)"
              class="exterior_checkbox"
              :id="index"
              name="color-radio"
              type="radio"
              :checked="index === selected_color_index"
            />
            <label :for="index">
              <img
                :src="detail.thumb"
                :name="detail.code"
                class="exterior_img"
              />
            </label>
          </slide>
          <template #addons> </template>
        </carousel>

        <p class="text_center select_color_info">
          {{ color_name }} ¥{{ color_price }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { props, context, inject, reactive, ref, onBeforeUpdate } from "vue";
import SwiperCore, { Navigation, A11y } from "swiper";
import { Swiper as Carousel, SwiperSlide as Slide } from "swiper/vue";

SwiperCore.use([Navigation, A11y]);

export default {
  name: "ColorSelectImage",
  props: ["color_images", "selected_color_index"],
  components: {
    Carousel: Carousel,
    Slide: Slide,
  },
  setup(props, context) {
    const exterior_image = ref([]);
    const color_name = ref();
    color_name.value = props.color_images[props.selected_color_index].name;
    const color_price = ref();
    color_price.value = props.color_images[props.selected_color_index].price;
    const pri_image_number = 0;
    const click_color_image = (code, index) => {
      context.emit("color_index", code, index);
      color_name.value = props.color_images[index].name;
      color_price.value = props.color_images[index].price;
    };
    let navigationDisplayJudge;
    const navigationDisplay = () => {
      if (window.matchMedia("(max-width:" + 560 + "px)").matches) {
        if (3 >= props.color_images.length) {
          return navigationDisplayJudge;
        } else {
          navigationDisplayJudge = true;
          return navigationDisplayJudge;
        }
      } else {
        if (6 >= props.color_images.length) {
          return navigationDisplayJudge;
        } else {
          navigationDisplayJudge = true;
          return navigationDisplayJudge;
        }
      }
    };
    

    return {
      color_name,
      color_price,
      click_color_image,
      exterior_image,
      pri_image_number,
      navigationDisplay,
      swiperOption: {
        // デフォルト（画面の幅が最も狭い時）のスライドの数などを設定(SP時は3枚にする)
        slidesPerView: 3,
        breakpoints: {
          767: {
            // 画面幅が768px以上の場合の設定を記述
            slidesPerView: 6,
            spaceBetween: 0,
          },
        },
      },
    };
  },
};
</script>

<style scoped>
</style>
